<template>
  <v-result :type="showType.H5" :types="type">
    <v-recommendHead v-if="type==headType.recommendMain"></v-recommendHead>
    <v-searchHead v-else-if="type==headType.searchResultHead" :type="headType.searchResultHead" :keywords="keyword"></v-searchHead>
    <div class="header-all" v-else>
      <v-classHead v-if="type==headType.recommend" :type="type" :title="title"></v-classHead>
      <v-cidHead v-else-if="type==headType.cidHead" :cid="cid"></v-cidHead>
    </div>
    <div style="height: 3rem" v-if="type==headType.recommend"></div>
    <div :style="cidHeadCss"  v-if="type==headType.cidHead"></div>
  </v-result>
</template>
<script>
  import Result from './Result.vue';
  import RecommendHeader from './taoke/RecommendHead.vue';
  import ClassHead from './taoke/ClassHeader.vue';
  import CidHead from './taoke/CidHeader.vue';
  import SearchHead from './taoke/SearchHeader.vue';
  export default{
    name:'Recommend',
    data(){
      return {
        type:this.$route.query.headType,
        title:this.$route.query.title,
        cid:this.$route.query.cid,
        keyword:this.$route.query.keyword,
        cidHeadCss:''
      }
    },
    components:{
      'v-result':Result,
      'v-recommendHead':RecommendHeader,
      'v-classHead':ClassHead,
      'v-cidHead':CidHead,
      'v-searchHead':SearchHead
    },
    beforeRouteUpdate (to, from, next) {

    },
    watch:{

    },
    created(){

    },
    mounted(){
      if(this.type==this.headType.cidHead){
        let seft = this;
        window.setTimeout(function(){
          seft.cidHeadCss = {"height":document.getElementById("cid").offsetTop+"px"};
        },10);
        this.public.cidParam = this.$route.query.q;
      }else if(this.type==this.headType.searchHead){
        this.public.keyParam = this.$route.query.q;
      }else{
        this.public.classParam = this.$route.query.q;
      }
      let seft = this;
      this.watcher.$on("goToRecommend",function(type,query,desc){
        seft.type = type;
        if(typeof query!='undefined' && query!=''){
          seft.public.classParam=query;
        }else{
          seft.public.classParam = '';
        }
        if(type==seft.headType.recommend){
          seft.title = desc;
        }
        this.public.toggleReload();
      });
      let uid = this.$route.query.uid;
      if(uid){
        this.setCookie("uid",uid,365);
      }
      let unionId = this.$route.query.unionId;
      if(unionId){
        this.setCookie("unionId",unionId,365);
      }
      if(this.$route.query.actNow){
        this.public.toggleReload();
      }
    },
    methods:{
      setCookie(key, value, day) {
        let date = new Date();
        date.setDate(date.getDate() + day);
        document.cookie = key + '=' + encodeURI(value) + ';expires=' + date;
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// RecommendResult.vue?09756e70